import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "Jan", orders: 47, cancelled: 35 },
  { name: "Refrigerated Van", orders: 75, cancelled: 25 },
  { name: "Refrigerated Van", orders: 50, cancelled: 5 },
  { name: "Box Truck", orders: 40, cancelled: 30 },
  { name: "PickUp Truck", orders: 55, cancelled: 15 },
];

const TotalOrders = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} barSize={100}>
        <CartesianGrid vertical={false} stroke="#E5E7EB" strokeOpacity={0.7} />
        <XAxis dataKey="name" />
        <YAxis ticks={[0, 25, 50, 75, 100]} tick={{ fontWeight: "700" }} />
        <Tooltip />
        <Bar dataKey="orders" fill="#3b82f6" stackId="a" name="Orders" />
        <Bar dataKey="cancelled" fill="#ef4444" stackId="a" name="Cancelled" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TotalOrders;
